import axios from '@fs/zion-axios'
import { useQuery } from 'react-query'
import { useEffectiveUser } from '@fs/zion-user'

export default function useUserSegment() {
  const { cisId } = useEffectiveUser()
  const response = useQuery({
    queryKey: ['userSegment', { cisId }],
    queryFn: () => getUserSegment(cisId),
  })
  return response
}

async function getUserSegment(userCisId) {
  if (!userCisId) {
    return undefined
  }
  return axios.get(`/service/home/pb/users/${userCisId}/segment?includeAncestorCountries=true`).then(({ data }) => {
    const userData = { ...data, ancestry: data.ancestralCountries }
    delete userData.ancestralCountries
    return userData
  })
}
